export default class AcompanhamentoCargaCIFCompleteParameters
{  
        IdFornecedor: number = 0;
        Pedido: number | null = null;
        SKU:  number | null = null;
        Descricao: string | null = null;
        Clifor:  number | null = null;
        QuantidadeCarregada: number | null = null;
        DataCarregamento: Date | null = null;
        DataEntrega: Date | null = null;
        PlacaCarreta: string | null = null;
        PlacaCavalo: string | null = null;
        Item: number | null = null;
        DataRemessa: Date | null =  null;
}
